import { render, staticRenderFns } from "./PatientDoctorsDialog.vue?vue&type=template&id=3f9c4d3d&scoped=true"
import script from "./PatientDoctorsDialog.vue?vue&type=script&lang=js"
export * from "./PatientDoctorsDialog.vue?vue&type=script&lang=js"
import style0 from "./PatientDoctorsDialog.vue?vue&type=style&index=0&id=3f9c4d3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9c4d3d",
  null
  
)

export default component.exports